import React, { memo } from 'react';
import { EngagementPlanTask } from '@redux/tasks/tasksTypes';
import { MessageReviewArea } from 'components/MessageReviewArea/MessageReviewArea';
import { PlanTaskDescriptionString } from 'components/PlanTaskDescriptionString/PlanTaskDescriptionString';
import { Text } from 'components/Typography';
import style from './TaskDetailsArea.scss';

type Props = {
  task: EngagementPlanTask;
};

export const TaskDetailsArea: React.FC<Props> = memo(({ task }) => {
  return (
    <div className={style.container}>
      <Text variant="h5" weight={500}>
        {task.taskName}
      </Text>
      <PlanTaskDescriptionString task={task} />
      {!!task.deliverableMessage && <MessageReviewArea message={task.deliverableMessage} containerStyle={style.messageArea} />}
    </div>
  );
});
